import clsx from "clsx";
import type { ButtonProps } from "@/src_new/shared/types";
import { getThemeClass, getThemeComponentGroup } from "@/src_new/shared/lib/themeComponentClasses";

export function Button({
  className,
  children,
  disabled,
  isLoading = false,
  loadingText,
  variant = "primary",
  type = "button",
  ...props
}: ButtonProps) {
  const buttonClasses = getThemeComponentGroup("button");
  const isDisabled = disabled || isLoading;
  const spinnerClassName =
    variant === "primary"
      ? getThemeClass(
          buttonClasses.solidTextColor,
          "border-theme-text-inverse/30 border-t-theme-text-inverse"
        )
      : getThemeClass(buttonClasses.outlineTextColor, "border-theme-text/20 border-t-theme-text");

  return (
    <button
      type={type}
      className={clsx(
        "inline-flex min-h-10 items-center justify-center px-4 text-sm font-semibold transition focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        buttonClasses.base,
        "rounded-md",
        variant === "primary"
          ? clsx(
              getThemeClass(buttonClasses.solidBgColor, "bg-theme-primary"),
              getThemeClass(buttonClasses.solidTextColor, "text-theme-text-inverse"),
              "bg-theme-primary",
              "hover:bg-theme-primary-hover",
              "hover:text-theme-text-inverse",
              buttonClasses.solid
            )
          : clsx(
              "border",
              getThemeClass(buttonClasses.outlineBorderColor, "border-theme-border-strong"),
              getThemeClass(buttonClasses.outlineTextColor, "text-theme-text-muted"),
              // "hover:bg-theme-surface-soft",
              "hover:bg-theme-primary-hover",
              "hover:text-theme-text-inverse",
              buttonClasses.solid
            ),
        className
      )}
      disabled={isDisabled}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          <span className={clsx("h-4 w-4 animate-spin rounded-md border-2", spinnerClassName)} />
          <span>{loadingText || children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
